import { Flex, FlexProps } from '@chakra-ui/react'

import Header from 'modules/product/components/Header'
import ProductForm from 'modules/product/components/ProductForm'
import ShareLinks from 'modules/product/ShareLinks'

import useProductOptions from '_app/hooks/useProductOptions'
import SectionWithDivider from 'modules/product/components/SectionWithDivider'
import ProductOptions from 'modules/product/components/ProductOptions'
import OrderInfo from 'modules/product/components/OrderInfo'
import Description from 'modules/product/components/Description'
import { BundleProduct } from '_app/types/api'
import { EngravingEntity } from '_app/types/cms'
import ProductEngrave from './components/ProductEngrave'
interface ProductInfoProps extends FlexProps {
  product: BundleProduct;
  mainImage: string;
  engravingsData: EngravingEntity[];
}

const ProductInfo = ({
  product,
  mainImage,
  engravingsData,
  ...props
}: ProductInfoProps) => {
  const productInfo = { product, upsellProducts: product.upsell_products } as any
  const {
    options,
    requiredOptions,
    productType,
  } =
    useProductOptions(productInfo)
  return (
    <Flex
      flexDirection="column"
      width={{ base: '100%', lg: '450px' }}
      {...props}
    >
      <SectionWithDivider>
        <ProductForm
          requiredOptions={requiredOptions}
          itemsOptions={product.items}
          sku={product.sku || ''}
          url_key={product.url_key || ''}
          salable_qty={product.salable_qty ?? 0}
          productId={(product.id ?? 0).toString()}
          productType={productType}
          product={product}
          header={
            <SectionWithDivider>
              <Header product={product} />
            </SectionWithDivider>
          }
        >
          {options && <ProductOptions options={options} />}
          <ProductEngrave {...{ product, requiredOptions, engravingsData }} />
        </ProductForm>
      </SectionWithDivider>
       <SectionWithDivider>
        <OrderInfo />
       </SectionWithDivider>
       {!!product.description?.html && (
        <SectionWithDivider>
          <Description {...product} />
        </SectionWithDivider>
       )}
       <SectionWithDivider>
        <ShareLinks name={product.name} image={mainImage} />
       </SectionWithDivider>
    </Flex>
  )
}

export default ProductInfo
